import React, { useState, useEffect } from 'react';
import './Reviews.css';

const AUTO_ADVANCE_MS = 6000;

function Reviews() {
    const [currentPage, setCurrentPage] = useState(0);
    const [reviewsPerPage, setReviewsPerPage] = useState(3);
    const [isPaused, setIsPaused] = useState(false);
    // Bumped on manual navigation so the timer restarts from a full interval.
    const [timerEpoch, setTimerEpoch] = useState(0);

    // Responsive review count based on viewport width
    useEffect(() => {
        const computeReviewsPerPage = () => {
            const w = window.innerWidth;
            if (w < 600) return 1; // phones
            if (w < 960) return 2; // tablets / small laptops
            return 3; // desktops
        };
        const update = () => {
            const newCount = computeReviewsPerPage();
            setReviewsPerPage(prev => {
                if (prev !== newCount) return newCount;
                return prev;
            });
        };
        update();
        window.addEventListener('resize', update);
        return () => window.removeEventListener('resize', update);
    }, []);

    const reviews = [
        {
            text: "Versiering voor mijn 18de verjaardag besteld bij Van Vlimmeren Feestverhuur. Ballonnen met de led cijfers, het was super mooi! Goed geregeld en duidelijke communicatie. Hier moet je zijn voor je decoratie.",
            author: "Jens Buurstede",
            rating: 5,
        },
        {
            text: "Geweldig mooi aangekleed met ballonnen en licht cijfers. Ook heel veel plezier gehad van de photobooth. Alles wordt geregeld. Top!",
            author: "Edwin Jaspers",
            rating: 5,
        },
        {
            text: "Ben altijd super tevreden over de versiering! En een hele goede service 🤩 ook de photobooth is geweldig!",
            author: "Luciana van Dorst",
            rating: 5,
        },
        {
            text: "Afgelopen Juni mijn verjaardag laten aankleden door Van Vlimmeren Feestverhuur, wat een service. Niets is te veel en vragen mogen altijd gesteld worden. Bedankt voor de goede service.",
            author: "Chloe Roks",
            rating: 5,
        },
        {
            text: "Super goed bedrijf! Snelle levering, fijn contact, oprecht en denkt altijd met je mee. Ga ik zeker vaker bij bestellen.",
            author: "Stef Pijnenburg",
            rating: 5,
        },
        {
            text: "Photobooth last minute geregeld voor mijn feest. Was goed geregeld en een super leuke aanvulling op het feest. Heel de avond gebruik van gemaakt 🎉",
            author: "Claudia Wagtmans",
            rating: 5,
        },
        {
            text: "Heel leuk de photobooth op je feest van Van Vlimmeren Feestverhuur!",
            author: "Danny de Bruijn",
            rating: 5,
        },
        {
            text: "Super service, goed contact, duidelijke afspraken die nagekomen worden. Heel fijn!",
            author: "Saskia Schepers",
            rating: 5,
        },
        {
            text: "Vriendelijk, goede communicatie en goede service",
            author: "Jordy Vissenberg",
            rating: 5,
        }
    ];

    const pageCount = Math.ceil(reviews.length / reviewsPerPage);

    // Clamp currentPage if pageCount reduced (e.g., on resize)
    useEffect(() => {
        setCurrentPage(p => (p >= pageCount ? pageCount - 1 : p));
    }, [pageCount]);

    // Auto-advance to the next page on a timer (phone and desktop alike);
    // paused while hovering, skipped entirely for reduced-motion users.
    useEffect(() => {
        if (isPaused || pageCount <= 1) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const id = setInterval(() => {
            setCurrentPage(p => (p + 1) % pageCount);
        }, AUTO_ADVANCE_MS);
        return () => clearInterval(id);
    }, [isPaused, pageCount, timerEpoch]);

    const displayedReviews = reviews.slice(
        currentPage * reviewsPerPage,
        (currentPage + 1) * reviewsPerPage
    );

    return (
        <section
            className="reviews-section"
            aria-labelledby="reviews-heading"
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}>
            <div className="reviews-title">
                <span className="reviews-eyebrow">04 — Recensies</span>
                <h2 id="reviews-heading">Wat onze klanten zeggen</h2>
                <div className="reviews-title-rule" aria-hidden="true"></div>
            </div>
            <div className="reviews-container" key={currentPage}>
                {displayedReviews.map((review, index) => (
                    <div
                        key={index}
                        className="review-card active"
                        style={{ "--stagger-index": index }}>
                        <div className="stars" aria-label={`Beoordeling: ${review.rating} van 5 sterren`}>
                            {[...Array(review.rating)].map((_, i) => (
                                <i key={i} className="fas fa-star" aria-hidden="true"></i>
                            ))}
                        </div>
                        <p className="review-text">{review.text}</p>
                        <p className="author-name">{review.author}</p>
                    </div>
                ))}
            </div>
            <div className="review-dots" role="navigation" aria-label="Review pagina's">
                {[...Array(pageCount)].map((_, index) => (
                    <button
                        key={index}
                        type="button"
                        className={`dot ${index === currentPage ? 'active' : ''}`}
                        aria-label={`Ga naar pagina ${index + 1}`}
                        aria-current={index === currentPage ? 'true' : undefined}
                        onClick={() => {
                            setCurrentPage(index);
                            setTimerEpoch(e => e + 1);
                        }}
                    ></button>
                ))}
            </div>
        </section>
    );
}

export default Reviews;

